export default [
    { value: 'individual', name: 'Individuali veikla' },
    { value: 'farmer', name: 'Ūkininko pažyma' },
    { value: 'license', name: 'Verslo liudijimas ar kt. terminuotas dokumentas' }
]
